import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterSeasonEvaluationEvent} from "@/modules/season/events/AfterSeasonEvaluationEvent";
import {CoachFactory} from "@/modules/training/services/SponsorFactory";
import {Coach} from "@/modules/training/entity";
import {Team} from "@/modules/team/entity";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";

@injectable()
export class GameCreationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(CoachFactory) private coachFactory: CoachFactory,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGameEvent},
    ];
  }

  async onAfterCreateGameEvent(event: AfterCreateGameEvent): Promise<void> {
    const team = await Team.current();

    await times(5).forEachAsync(() => this.coachFactory.generate());

    await times(1).forEachAsync(async () => {
      const coach = await this.coachFactory.generate();
      coach.team = team;

      await coach.save();
    });
    await times(1).forEachAsync(async () => {
      const coach = await this.coachFactory.generate() as Coach;
      coach.team = team;
      coach.positionArea = undefined;

      await coach.save();
    });
  }
}